import {
  GET_BUDGET_PERCENTAGE_PROFILE,
  GET_BUDGET_PERCENTAGE_PROFILE_FAIL,
  GET_BUDGET_PERCENTAGE_PROFILE_SUCCESS,
  GET_BUDGETS_PERCENTAGE,
  GET_BUDGETS_PERCENTAGE_FAIL,
  GET_BUDGETS_PERCENTAGE_SUCCESS,
  ADD_NEW_BUDGET_PERCENTAGE,
  ADD_BUDGET_PERCENTAGE_SUCCESS,
  ADD_BUDGET_PERCENTAGE_FAIL,
  UPDATE_BUDGET_PERCENTAGE,
  UPDATE_BUDGET_PERCENTAGE_SUCCESS,
  UPDATE_BUDGET_PERCENTAGE_FAIL,
  DELETE_BUDGET_PERCENTAGE,
  DELETE_BUDGET_PERCENTAGE_SUCCESS,
  DELETE_BUDGET_PERCENTAGE_FAIL,
} from "./actionTypes"

export const getBudget_percentage = ({offset,page_size}) => ({
  type: GET_BUDGETS_PERCENTAGE,
  payload:{offset,page_size}
})

export const getBudgets_percentageSuccess = budget_percentage => ({
  type: GET_BUDGETS_PERCENTAGE_SUCCESS,
  payload: budget_percentage,
})

export const getBudgets_percentageFail = error => ({
  type: GET_BUDGETS_PERCENTAGE_FAIL,
  payload: error,
})

export const addNewBudget_percentage = user => ({
  type: ADD_NEW_BUDGET_PERCENTAGE,
  payload: user,
})

export const addBudget_percentageSuccess = user => ({
  type: ADD_BUDGET_PERCENTAGE_SUCCESS,
  payload: user,
})  

export const addBudget_percentageFail = error => ({
  type: ADD_BUDGET_PERCENTAGE_FAIL,
  payload: error,
})

export const updateBudget_percentage = user => ({
  type: UPDATE_BUDGET_PERCENTAGE,
  payload: user,
})

export const updateBudget_percentageSuccess = user => ({
  type: UPDATE_BUDGET_PERCENTAGE_SUCCESS,
  payload: user,
})

export const updateBudget_percentageFail = error => ({
  type: UPDATE_BUDGET_PERCENTAGE_FAIL,
  payload: error,
})

export const deleteBudget_percentage = user => ({
  type: DELETE_BUDGET_PERCENTAGE,
  payload: user,
})

export const deleteBudget_percentageSuccess = user => ({
  type: DELETE_BUDGET_PERCENTAGE_SUCCESS,
  payload: user,
})

export const deleteBudget_percentageFail = error => ({
  type: DELETE_BUDGET_PERCENTAGE_FAIL,
  payload: error,
})

export const getBudget_percentageProfile = () => ({
  type: GET_BUDGET_PERCENTAGE_PROFILE,
})

export const getBudget_percentageProfileSuccess = userProfile => ({
  type: GET_BUDGET_PERCENTAGE_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getBudget_percentageProfileFail = error => ({
  type: GET_BUDGET_PERCENTAGE_PROFILE_FAIL,
  payload: error,
})
